export default {
  pages: {
    key: "title",
    data: [
      { title: 'Home', url: '/', icon: 'HomeIcon', is_bookmarked: false },
      { title: 'Events', url: '/events', icon: 'FileIcon', is_bookmarked: false },
      { title: 'Ticket', url: '/tickets', icon: 'FileIcon', is_bookmarked: false },
    ]
  }
}
